import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useMapGeometry } from "@/features/matches";
import { Skeleton } from "@/shared/ui/skeleton";

import { useAnalysisMap } from "../../api/useAnalysisMap";
import type { MapGeometry, MatchMap as MatchMapData } from "../../model/Analysis";
import { MatchMapView } from "./MatchMapView";

const UNAVAILABLE = msg({
  id: "analysis.map.unavailable",
  message: "The map of this match is not available yet.",
});

type MatchMapProps = {
  analysisId: number;
};

// Тепловая карта готового разбора: данные матча и геометрия карты — двумя запросами.
// Чего-то нет (справочник карты ещё не загружен) — короткое сообщение вместо карты.
export const MatchMap = ({ analysisId }: MatchMapProps) => {
  const { _ } = useLingui();
  const match = useAnalysisMap(analysisId);
  const geometry = useMapGeometry();
  if (match.isPending || geometry.isPending) {
    return <Skeleton className="h-[560px] rounded-xl" />;
  }
  if (match.isError || geometry.isError) {
    return (
      <p className="rounded-xl border border-border bg-surface px-4.5 py-4 text-sm text-muted">
        {_(UNAVAILABLE)}
      </p>
    );
  }
  // Типы ответа openapi-fetch делают из кортежей схемы (`[u, v, hp]`) обычные массивы;
  // данные — ровно по схеме, поэтому берём её типы.
  // Другой разбор — карта заново, с его первой смерти.
  return (
    <MatchMapView
      key={analysisId}
      match={match.data as MatchMapData}
      geometry={geometry.data as MapGeometry}
    />
  );
};
